import Raven from 'raven-js';
import { Provider } from 'react-redux';
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { initializePortal } from 'portals-platform-lib';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import { Routes } from './components/Routes';
import { AuthWrapper } from './containers/AuthWrapper';
import { PageLayout } from './components/layouts/PageLayout';
import { store } from './redux/store';
import { initUsageTracker } from './utils/usageTracker';
import { Metrics } from './utils/Metrics';
import { PortalsPlatformDataProvider } from './hooks/usePortalPlatformData';
import { ErrorActions } from './constants/ErrorActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export { getLocaleInfo } from 'portals-platform-lib';
export const prepareApp = async () => {
  initUsageTracker();
  const client = new DataFetchingClient({
    onFetcherRejection: (reason, operationInfo) => {
      Metrics.counter('dfc-fetch-error', {
        operation: operationInfo.fieldName
      }).increment();
      Raven.captureMessage(`DFC ${operationInfo.operationType} error: ${operationInfo.fieldName}`, {
        extra: {
          variables: operationInfo.variables,
          reason
        }
      });
    }
  });
  let portalData = null;
  const startTime = performance.now();
  try {
    const result = await initializePortal();
    portalData = result.portalData;
    Metrics.timer('initialize-portal-duration').update(performance.now() - startTime);
    Metrics.counter('initialize-portal-success').increment();
  } catch (error) {
    Metrics.timer('initialize-portal-duration').update(performance.now() - startTime);
    Metrics.counter('initialize-portal-failure').increment();
    Raven.captureException(error instanceof Error ? error : new Error(String(error)), {
      tags: {
        action: ErrorActions.INITIALIZE_PORTAL
      }
    });
    console.error('Failed to fetch portal data:', error);
  }
  return {
    props: {
      dataFetchingClient: client,
      portalData
    }
  };
};
export function AppComponent({
  dataFetchingClient,
  portalData
}) {
  return /*#__PURE__*/_jsx(DataFetchingClientProvider, {
    client: dataFetchingClient,
    children: /*#__PURE__*/_jsx(Provider, {
      store: store,
      children: /*#__PURE__*/_jsx(PortalsPlatformDataProvider, {
        portalData: portalData,
        children: /*#__PURE__*/_jsxs(AuthWrapper, {
          children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), /*#__PURE__*/_jsx(PageLayout, {
            children: /*#__PURE__*/_jsx(Routes, {})
          })]
        })
      })
    })
  });
}